import { t } from "i18next"

const pipelineSummaryTransformer = response => {
  return response?.summary?.summary
}

const pipelineForcastedWidgetTransformer = response => {
  const { data = [], currentPipeline, forecastedPipeline } = response || {}

  const barChartData = data.flatMap(user => {
    const stacks = {
      Sold: { current: user?.sold, forecasted: user?.sold },
      "Partial Sold": { current: user?.partiallySold, forecasted: user?.partiallySold },
      "Token/Preclosure": { current: user?.preclosure },
      "Forecasted Probability": { forecasted: user?.forecastedRevenue },
    }

    const COLUMN_ORDER = {
      current: ["Sold", "Partial Sold", "Token/Preclosure"],
      forecasted: ["Sold", "Partial Sold", "Forecasted Probability"],
    }

    return ["current", "forecasted"].flatMap(column =>
      COLUMN_ORDER[column].map(type => ({
        name: user?.name,
        column,
        type,
        value: stacks[type]?.[column] ?? 0,
      }))
    )
  })

  return {
    barChartData: data?.length ? barChartData : [{ name: t("No Staff") }],
    currentPipeline,
    forecastedPipeline,
  }
}

export const pipelineReportTransformer = (response, args) => {
  if (args?.load === "summary") return pipelineSummaryTransformer(response)
  else if (args?.load === "forecasted_widget") return pipelineForcastedWidgetTransformer(response?.forecastedWidget)
}
